















































import { editFactory } from '@/main/pages';
import { editName } from '@/main/store/listEditTypes';
import DmsDphCalculator from '@/main/components/dms/dphCalculator/DmsDphCalculator.vue';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { Texty } from '@/modules/ciselnik/firemni/texty';
import { SkladoveMistoPneu } from '@/modules/ciselnik/pneu/skladoveMistoPneu';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
	components: {
		DmsDphCalculator,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		TextySelect: Texty.components.Select,
		SkladMistoPneuSelect: SkladoveMistoPneu.components.SelectInput,
	},
	computed: {
		mutationsMappers() {
			return {
				texty: `${this.storeUri}/${editMutations.SKLAD_PNEU_TEXTY_SELECT_MAPPER}`,
			};
		},
		textyFilter() {
			return {
				SkladpneuPrp: true,
			};
		},
	},
});
